import React from 'react';
import { Header, Icon } from 'semantic-ui-react';

const DialogHeaderWrapper = ({
  children,
  icon,
  loading,
  title,
}) => (
  <Header className="aridhia-error-header-wrapper" size="large" title={title}>
    <Header.Content>
      {icon && (<Icon name={loading ? 'circle notched' : icon} className="primary" loading={loading} />)}
      {title}
    </Header.Content>
    { children }
  </Header>
);

export default DialogHeaderWrapper;
